(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["plutonic-noeglefakta"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function (event) {
    var link = event.target.closest('.plutonic-noeglefakta__link');
    if (!link) return;
    var maal = document.getElementById('plutonic-specifikationer');
    if (!maal) return;
    var fane = maal.closest('details');
    event.preventDefault();
    if (fane && !fane.open) {
      var knap = fane.querySelector('summary');
      if (knap) {
        knap.click();
      } else {
        fane.open = true;
      }
    }
    var rolig = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    (fane || maal).scrollIntoView({ behavior: rolig ? 'auto' : 'smooth', block: 'start' });
  });
  } catch(e) { console.error(e); }
})();

})();
